import { Spacer } from '@chakra-ui/react';
import PieChartCompanyList from 'presentation/components/shared/chart/pieChart/PieChartCompanyList';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PeClientsPieChart from './PeClientsPieChart';
import useAppSelector from 'hooks/shared/store/useAppSelector';
import { companiesPieColorsSelector } from 'selectors/modules/companies/companiesPieColors';
import useUpdateCompaniesPieColors from 'hooks/modules/companiesPieColors/useUpdateCompaniesPieColors';

interface Props {
  clients: PeCompanyClient[];
}

const PeCompanyClientsSection: FC<Props> = ({ clients }) => {
  const { t } = useTranslation();

  const pieColors = useAppSelector(companiesPieColorsSelector);

  useUpdateCompaniesPieColors(clients.map((client) => client.name));

  return (
    <>
      <GridHeading>{t('peCompanyClients')}</GridHeading>
      <AppCard p="20px" display="flex">
        <PeClientsPieChart clients={clients} pieColors={pieColors} />
        <Spacer maxW="40px" w="40px" />
        <PieChartCompanyList items={clients} pieColors={pieColors} />
      </AppCard>
    </>
  );
};

export default PeCompanyClientsSection;
